export enum MenuCallback {
  PLEXTERA_LINK = 'PLEXTERA_LINK',
}
